import BaseApi from "../baseApi";
import {PROJECT_FILE} from "../apiConstant";

class ProjectFile extends BaseApi {
    constructor() {
        super();
        this.BASE_URL = process.env.REACT_APP_PROJECT_MANAGEMENT_API_URL || "";
        this.$axiosInstance = this.initAxiosInstance();
    }


    delete(body) {
        return this.post(`${PROJECT_FILE}/delete`, body);
    }

    getFiles(body) {
        return this.post(`${PROJECT_FILE}/attachFile`, body);
    }

    mergeChunk(body) {
        return this.post(`${PROJECT_FILE}/sendChunk`, body);
    }
}
export default ProjectFile;
